<template>
  <div>
    <my-header></my-header>

    <div class="section-container">
      <side-nav
        :menuItems="menuItems"
        class="side-nav"
      />

      <div class="content-box">
        <h2>Управление статистикой</h2>
        <router-view></router-view>
      </div>
    </div>

  </div>
</template>

<script>
import MyHeader from '../Header.vue';
import SideNav from '../SideNav.vue';

export default {
  name: 'LevelsConfPanel',

  components: {
    MyHeader,
    SideNav,
  },

  computed: {
    menuItems() {
      return [
        {
          title: 'Создание отчетов',
          route: {name: 'm3_reports_building'},
        },
        {
          title: 'Неправильные названия прототипов уровней',
          route: {name: 'm3_invalid_level_proto_names'},
        }
      ];
    }
  }
}
</script>

<style scoped>
.section-container {
  display: flex;
}

.side-nav {
  margin-right: 3em;
}

.content-box {
  width: 600px;
  padding-top: 1em;
}
</style>
